import React, { useEffect, useState } from "react";
import style from "../documentConfig/createDeclaration.module.css";
import Input from "../../components/Input";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import axios from "axios";
import { BASE_URL } from "../../constants/Constants";
import BoxComponent from "../../components/CommonComponents/BoxComponent/BoxComponent";
import { useUser } from "../../contexts/UserContext";
import { _axios } from "../../utils/axios";

interface Declaration {
  active: number;
  declaration_id: number | string;
  // Add other properties as needed
}

const CreateDeclaration = () => {
  const { state } = useLocation();
  const declarationData = state?.declarationData;
  const navigate = useNavigate();
  const [allDeclarations, setAllDeclarations] = useState<Declaration[]>([]);
  const [documentType, setDocumentType] = useState([])
  const [formData, setFormData] = useState({
    declaration_name: declarationData?.declaration_name ?? "",
    declaration_details: declarationData?.declaration_details ?? "",
    active: declarationData?.active === 1 ?? false,
    form_type: declarationData?.form_type ?? "",
    mandatory: declarationData?.mandatory === 1 ?? false,
  });

  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    // Handle form submission logic here, such as sending data to a server.
  };

  useEffect(() => {
    _axios.post(`${BASE_URL}/api/declaration-config/list`)
      .then(response => {
        setAllDeclarations(response.data.data.results as Declaration[]);
      })
      .catch(error => {
        console.error("Error fetching declarations:", error);
      });
  }, []);

  const onSubmit = () => {

    if (formData.declaration_name.length === 0) {
      ErrorToast("Please enter a valid Document Label")
      return
    }
    if (formData.declaration_details.length === 0) {
      ErrorToast("Please enter a valid Document Name")
      return
    }
    if (formData.form_type.length === 0) {
      ErrorToast("Please enter a valid Document Type")
      return
    }

    if (!formData.active && formData.mandatory) {
      ErrorToast("Deactivated Declaration cannot be Mandatory");
      return;
    }

    const activeDeclarations = allDeclarations.filter(
      declaration => declaration.active === 1
    );
    if (
      !formData.active &&
      activeDeclarations.length === 1 &&
      activeDeclarations[0].declaration_id === declarationData?.declaration_id
    ) {
      ErrorToast("At least one Declaration should be Active");
      return;
    }

    const data = {
      declaration_name: formData.declaration_name,
      declaration_details: formData.declaration_details,
      form_type: formData.form_type,
      mandatory: formData.mandatory ? 1 : 0,
      active: formData.active ? 1 : 0,
    }

    if (declarationData !== undefined) {
      _axios.patch(`${BASE_URL}/api/declaration-config`, { ...data, declaration_id: declarationData?.declaration_id })
        .then(function (response) {
          console.log('response', response);
          if (response?.data?.success === 0) {
            ErrorToast(response?.data?.message)
            return
          }
          SuccessToast('Declaration Config Updated')
          navigate('/document-config', { state: { tab: 2 } });

          // handle success

        })
        .catch(function (error) {
          // handle error
          if (error?.response?.data?.message) {
            ErrorToast(error?.response?.data?.message)
          }
          console.log('error', error);
        })
    }
    else {
      _axios.post(`${BASE_URL}/api/declaration-config`, data)
        .then(function (response) {
          console.log('response', response);
          if (response?.data?.success === 0) {
            ErrorToast(response?.data?.message)
            return
          }
          SuccessToast('Declaration Config Added')
          navigate('/document-config', { state: { tab: 2 } });

          // handle success

        })
        .catch(function (error) {
          // handle error
          if (error?.response?.data?.message) {
            ErrorToast(error?.response?.data?.message)
          }
          console.log('error', error);
        })
    }
  }

  return (
    <div className={style.body}>
      <div className={style.divbodyheading}>
        <p className={style.bodytitle}>Create Declaration</p>
      </div>
      <form onSubmit={handleSubmit}>
        <BoxComponent>
          <div className={style.navbar}>
            <div className={style.userform}>
              <div className={style.formrow}>
                <div className={style.formgroup}>
                  <div className={style.loginText}>Declaration Name </div>
                  <input
                    type="text"
                    id="declarationName"
                    name="declaration_name"
                    placeholder="Declaration"
                    value={formData.declaration_name}
                    onChange={handleInputChange}
                  />
                </div>

                <div className={style.formgroup}>
                  <div className={style.loginText}>Form Type</div>
                  <select
                    id="formType"
                    name="form_type"
                    className="selectwhite"
                    value={formData.form_type}
                    onChange={handleInputChange}
                  >
                    <option value="Basic Form">Basic Form</option>
                    <option value="Document Form">Document Form</option>
                    <option value="Service Form">Service Form</option>
                  </select>
                </div>
              </div>
              <div className={style.formrow}>
                <div className={style.formgroup}>
                  <div className={style.loginText}>Declaration </div>
                  <div className={style.declarationName}>
                    <input
                      type="tell"
                      id="declaration"
                      name="declaration_details"
                      placeholder="Declaration"
                      value={formData.declaration_details}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
              <div className={style.formrow}>
                <div className={style.formgroup}>
                  <div className={style.footerActive}>
                    <label className={style.footerAct}>Mandatory</label>
                    <div className={style.footerAct}>
                      <label className={style.toggleBtn}>
                        <input type="checkbox" className={style.inputCheckbox} checked={formData.mandatory} onClick={() => handleInputChange({ target: { name: 'mandatory', value: !formData.mandatory } })} />
                        <span className={style.slider}></span>
                      </label>
                    </div>
                    {/* </div> */}
                    {/* <div className={style.footerActive}> */}
                    {/* <label className={style.footerAct}>Activate</label>
                  <div className={style.footerAct}>
                    <label className={style.toggleBtn}>
                      <input type="checkbox" className={style.inputCheckbox} checked={formData.active} onClick={() => handleInputChange({ target: { name: 'active', value: !formData.active } })} />
                      <span className={style.slider}></span>
                    </label>
                  </div> */}
                  </div>
                </div>
              </div>

              <div className={style.formrow}>
                <div className={style.formgroup}>
                  <div className={style.footerActive}>
                    <label className={style.footerAct}>Activate</label>
                    <div className={style.footerAct}>
                      <label className={style.toggleBtn}>
                        <input type="checkbox" className={style.inputCheckbox} checked={formData.active} onClick={() => handleInputChange({ target: { name: 'active', value: !formData.active } })} />
                        <span className={style.slider}></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className={style.buttonSection}>
                <button className={style.publishButton} onClick={onSubmit}>Publish</button>
                <button className={style.closeButton} onClick={() => { navigate("/document-config", { state: { tab: 2 } }) }}>Close</button>
              </div>
            </div>
          </div>
        </BoxComponent>
      </form >
    </div >
  );
};

export default CreateDeclaration;